import axios from 'axios';

/**
 * This used to have a cache layer in here. It's been temporarily removed because we were having weird issues and we
 * wanted to eliminate this as the cause.
 * @param url
 * @param options
 * @returns {Promise<void>}
 */
const dataFetch = async function(url, options = {} /*, cacheMaxAge*/) {
  const res = await axios.get(url, options);
  return res.data;
};

const dataPost = async function(url, data = {}, config = {} /*, cacheMaxAge*/) {
  const instance = axios.create({
    withCredentials: true,
  });
  const res = await instance.post(url, data, config);
  return res;
};
const dataDelete = async function(url, options = {} /*, cacheMaxAge*/) {
  const res = await axios.delete(url, options);
  return res.data;
};

export { dataFetch, dataPost, dataDelete };
